// import React, { useContext } from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import { AuthContext } from "../context/AuthContext";

// const ProtectedRoute = () => {
//   const { isAuthenticated } = useContext(AuthContext);

//   return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
// };

// export default ProtectedRoute;

// src/routes/ProtectedRoute.jsx
import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ allowedRoles }) => {
  const { isAuthenticated, user_type } = useContext(AuthContext);

  // ⛔ Not logged in — redirect to sign-in
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // ✅ Logged in and role is allowed — render the protected component
  if (allowedRoles.includes(user_type)) {
    return <Outlet />;
  }

  // 🚫 Logged in but role not allowed — show unauthorized message
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-2">403 - Unauthorized</h1>
        <p className="text-gray-600">
          You do not have permission to view this page.
        </p>
      </div>
    </div>
  );
};

export default ProtectedRoute;
